import { useState, type ReactNode } from 'react'
import { ChevronDown, Filter, RotateCcw } from 'lucide-react'

interface AdvancedFiltersProps {
  activeCount: number
  onReset: () => void
  onApply?: () => void
  children: ReactNode
  className?: string
}

export default function AdvancedFilters({ activeCount, onReset, onApply, children, className = '' }: AdvancedFiltersProps) {
  const [open, setOpen] = useState(false)

  return (
    <div className={`w-full border-t border-slate-100 ${className}`}>
      <div className="flex items-center gap-2 pt-3">
        <button
          type="button"
          onClick={() => setOpen(value => !value)}
          className="inline-flex items-center gap-2 rounded-lg border border-slate-200 px-3 py-1.5 text-sm font-medium text-slate-700 hover:bg-slate-50"
          aria-expanded={open}
        >
          <Filter size={15} />
          Advanced filters
          {activeCount > 0 && (
            <span className="rounded-full bg-red-100 px-1.5 py-0.5 text-xs font-semibold text-red-800">
              {activeCount}
            </span>
          )}
          <ChevronDown size={15} className={`transition-transform ${open ? 'rotate-180' : ''}`} />
        </button>
        {activeCount > 0 && (
          <>
            <span className="text-xs text-slate-500">{activeCount} active filter{activeCount === 1 ? '' : 's'}</span>
            <button
              type="button"
              onClick={onReset}
              className="inline-flex items-center gap-1 text-xs font-medium text-red-700 hover:text-red-900"
            >
              <RotateCcw size={13} /> Reset
            </button>
          </>
        )}
      </div>
      {open && (
        <div className="mt-3 rounded-lg bg-slate-50 p-3">
          <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
            {children}
          </div>
          <div className="mt-3 flex justify-end gap-2 border-t border-slate-200 pt-3">
            <button type="button" onClick={onReset} className="rounded-lg border border-slate-200 px-3 py-1.5 text-sm text-slate-700 hover:bg-white">
              Reset filters
            </button>
            <button type="button" onClick={() => { onApply?.(); setOpen(false) }} className="rounded-lg bg-red-800 px-3 py-1.5 text-sm font-medium text-white hover:bg-red-900">
              Apply filters
            </button>
          </div>
        </div>
      )}
    </div>
  )
}